import script from "./AlignCenterIcon.vue?vue&type=script&setup=true&lang=js"
export * from "./AlignCenterIcon.vue?vue&type=script&setup=true&lang=js"

export default script